import { NgModule } from '@angular/core';
import { CommonModule, NgClass, NgForOf, NgIf } from '@angular/common';
import { TrialsListComponent } from './trials-list/trials-list.component';
import { SharedModule } from "../../shared/shared.module";
import { TrialAddComponent } from './trial-add/trial-add.component';
import { TrialEditComponent } from './trial-edit/trial-edit.component';
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TrialDetailsComponent } from './trial-details/trial-details.component';
import { TrialAssignSiteComponent } from "./trial-details/trial-sites/trial-assign-site/trial-assign-site.component";
import { TrialChangeLogComponent } from "./trial-details/trial-change-log/trial-change-log.component";
import { TrialSitesComponent } from "./trial-details/trial-sites/trial-sites.component";
import { TrialNewSiteComponent } from "./trial-details/trial-sites/trial-new-site/trial-new-site.component";
import { TrialPatientsComponent } from "./trial-details/trial-patients/trial-patients.component";
import { TrialPoliciesComponent } from "./trial-details/trial-policies/trial-policies.component";
import { TrialReportComponent } from './trial-report/trial-report.component';
import { TrialInfoComponent } from './trial-details/trial-info/trial-info.component';
import { TrialPaymentsComponent } from './trial-details/trial-payments/trial-payments.component';
import { TrialPolicyAddComponent } from './trial-details/trial-policies/trial-policy-add/trial-policy-add.component';
import { TrialPolicyRowComponent } from './trial-details/trial-policies/trial-policy-row/trial-policy-row.component';
import { TrialPolicyEditComponent } from './trial-details/trial-policies/trial-policy-edit/trial-policy-edit.component';
import { TrialUpdateSiteComponent } from './trial-details/trial-sites/trial-update-site/trial-update-site.component';
import { AdminModule } from '../admin/admin.module';
import {
  ManageSiteContactsComponent
} from './trial-details/trial-sites/manage-site-contacts/manage-site-contacts.component';
import {
  TrialAssignPatientModalComponent
} from './trial-details/trial-assign-patient-modal/trial-assign-patient-modal.component';
import { TrialMailboxComponent } from './trial-details/trial-mailbox/trial-mailbox.component';
import { TrialVisitScheduleComponent } from './trial-details/trial-visit-schedule/trial-visit-schedule.component';
import { DragDropModule } from "@angular/cdk/drag-drop";
import { TrialBookingsComponent } from "./trial-bookings/trial-bookings.component";
import {
  TrialBookingConfigModalComponent
} from "./trial-bookings/trial-bookings-config/trial-booking-config-modal/trial-booking-config-modal.component";
import { TrialBookingsConfigComponent } from "./trial-bookings/trial-bookings-config/trial-bookings-config.component";
import { TrialUsersComponent } from './trial-details/trial-users/trial-users.component';
import {
  CreateExpenseRuleModalComponent
} from './trial-details/trial-policies/create-expense-rule-modal/create-expense-rule-modal.component';
import {
  UpdateExpenseRuleModalComponent
} from './trial-details/trial-policies/update-expense-rule-modal/update-expense-rule-modal.component';
import {
  TrialPolicyMileageRatesComponent
} from './trial-details/trial-policies/trial-policy-mileage-rates/trial-policy-mileage-rates.component';
import {
  TrialPolicyExpenseRulesComponent
} from './trial-details/trial-policies/trial-policy-expense-rules/trial-policy-expense-rules.component';
import {
  CreateMileageRateRuleModalComponent
} from './trial-details/trial-policies/create-mileage-rate-rule-modal/create-mileage-rate-rule-modal.component';
import {
  UpdateMileageRateRuleModalComponent
} from './trial-details/trial-policies/update-mileage-rate-rule-modal/update-mileage-rate-rule-modal.component';
import { MatIconModule } from '@angular/material/icon';
import {
  TrialPolicyRulesListComponent
} from './trial-details/trial-policies/trial-policy-rules-list/trial-policy-rules-list.component';
import {
  TrialPolicyMileageRatesListComponent
} from './trial-details/trial-policies/trial-policy-mileage-rates-list/trial-policy-mileage-rates-list.component';
import { VisitModule } from "../visit/visit.module";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatTableModule } from "@angular/material/table";
import { MatInputModule } from "@angular/material/input";
import { TrialIntegrationComponent } from "./trial-details/trial-integration/trial-integration.component";
import { TrialRoleToggleComponent } from "./trial-details/trial-users/trial-role-toggle/trial-role-toggle.component";
import { VisitAutoPaymentsComponent } from "./trial-details/visit-auto-payments/visit-auto-payments.component";
import { VisitPreloadPaymentsComponent } from "./trial-details/visit-preload-payments/visit-preload-payments.component";
import { ButtonComponent } from "../../shared/button/button.component";
import { ClickOutsideDirective } from "../../core/directives/click-outside.directive";
import { TrialGenericDiaryComponent } from "./trial-details/trial-generic-diary/trial-generic-diary.component";
import {
  TrialPolicyCloneComponent
} from "./trial-details/trial-policies/trial-policy-clone/trial-policy-clone.component";
import { TrialPolicyCardComponent } from "./trial-details/trial-policies/trial-policy-card/trial-policy-card.component";
import { TrialDiaryFormComponent } from "./trial-details/trial-diary-form/trial-diary-form.component";
import { TrialDiariesComponent } from "./trial-details/trial-diaries/trial-diaries.component";
import {
  TrialDiaryFormElementRendererComponent
} from "./trial-details/trial-diary-form/trial-diary-form-element-renderer/trial-diary-form-element-renderer.component";
import {
  ElementSingleLineComponent
} from "./trial-details/trial-diary-form/element-single-line/element-single-line.component";
import { ElementCheckboxComponent } from "./trial-details/trial-diary-form/element-checkbox/element-checkbox.component";
import {
  ElementMultiLineComponent
} from "./trial-details/trial-diary-form/element-multi-line/element-multi-line.component";
import { ElementNumericComponent } from "./trial-details/trial-diary-form/element-numeric/element-numeric.component";
import { ElementRadioComponent } from "./trial-details/trial-diary-form/element-radio/element-radio.component";
import {
  ElementContextMenuComponent
} from "./trial-details/trial-diary-form/element-context-menu/element-context-menu.component";
import { ElementDropdownComponent } from "./trial-details/trial-diary-form/element-dropdown/element-dropdown.component";
import {
  ElementSettingsModalComponent
} from "./trial-details/trial-diary-form/element-settings-modal/element-settings-modal.component";
import { CheckboxComponent } from "../../shared/checkbox/checkbox.component";
import { ElementLabelComponent } from "./trial-details/trial-diary-form/element-label/element-label.component";
import {
  ElementOptionListComponent
} from "./trial-details/trial-diary-form/element-option-list/element-option-list.component";
import {
  TrialDiaryConfigModalComponent
} from "./trial-details/trial-diary-form/trial-diary-config-modal/trial-diary-config-modal.component";
import {
  TrialDiaryRulesComponent
} from "./trial-details/trial-diary-form/trial-diary-rules/trial-diary-rules.component";
import {
  TrialDiaryAddRuleModalComponent
} from "./trial-details/trial-diary-form/trial-diary-add-rule-modal/trial-diary-add-rule-modal.component";
import {
  TrialDiaryAddRuleConditionComponent
} from "./trial-details/trial-diary-form/trial-diary-add-rule-modal/trial-diary-add-rule-condition/trial-diary-add-rule-condition.component";
import { ElementTimeComponent } from "./trial-details/trial-diary-form/element-time/element-time.component";
import { ElementDateComponent } from "./trial-details/trial-diary-form/element-date/element-date.component";
import { PlatformChartComponent } from "./trial-report/platform-chart/platform-chart.component";
import { PanelComponent } from "../../shared/panel/panel.component";
import { TrialSupportComponent } from "./trial-details/trial-support/trial-support.component";
import {
  TrialSupportContactsComponent
} from "./trial-details/trial-support/trial-support-contacts/trial-support-contacts.component";
import {
  TrialContactsTableRowComponent
} from "./trial-details/trial-support/trial-support-contacts/trial-contacts-table-row/trial-contacts-table-row.component";
import {
  TrialSupportLinksComponent
} from "./trial-details/trial-support/trial-support-links/trial-support-links.component";
import {
  TrialSupportInfoComponent
} from "./trial-details/trial-support/trial-support-info/trial-support-info.component";
import {
  TrialSupportLinkFormComponent
} from "./trial-details/trial-support/trial-support-links/trial-support-link-form/trial-support-link-form.component";
import { TrialFaqsComponent } from "./trial-details/trial-faqs/trial-faqs.component";
import { FaqFormComponent } from "./trial-details/trial-faqs/faq-form/faq-form.component";
import { TrialNotificationsComponent } from "./trial-details/trial-notifications/trial-notifications.component";
import { TrialInformationComponent } from "./trial-details/trial-information/trial-information.component";
import { SwitchPanelComponent } from "../../shared/switch-panel/switch-panel.component";
import {
  ElementContainerComponent
} from "./trial-details/trial-diary-form/element-container/element-container.component";
import { ElementMessagesComponent } from "./trial-details/trial-diary-form/element-messages/element-messages.component";
import {
  ElementMessageModalComponent
} from "./trial-details/trial-diary-form/element-message-modal/element-message-modal.component";
import {
  ElementVisibilityModalComponent
} from "./trial-details/trial-diary-form/element-visibility-modal/element-visibility-modal.component";
import { PgoCallout } from "../../shared/pgo-callout/pgo-callout";
import {
  TrialPolicyEdiaryPaymentsComponent
} from "./trial-details/trial-policies/trial-policy-ediary-payments/trial-policy-ediary-payments.component";

@NgModule({
  declarations: [
    TrialsListComponent,
    TrialAddComponent,
    TrialEditComponent,
    TrialDetailsComponent,
    TrialAssignSiteComponent,
    TrialSitesComponent,
    TrialNewSiteComponent,
    TrialPatientsComponent,
    TrialPoliciesComponent,
    TrialChangeLogComponent,
    TrialSupportContactsComponent,
    TrialReportComponent,
    TrialInfoComponent,
    TrialPaymentsComponent,
    TrialPolicyAddComponent,
    TrialPolicyRowComponent,
    TrialPolicyEditComponent,
    TrialUpdateSiteComponent,
    ManageSiteContactsComponent,
    TrialAssignPatientModalComponent,
    TrialVisitScheduleComponent,
    TrialMailboxComponent,
    TrialBookingsComponent,
    TrialBookingConfigModalComponent,
    TrialBookingsConfigComponent,
    TrialUsersComponent,
    TrialPolicyExpenseRulesComponent,
    CreateExpenseRuleModalComponent,
    UpdateExpenseRuleModalComponent,
    TrialPolicyMileageRatesComponent,
    CreateMileageRateRuleModalComponent,
    UpdateMileageRateRuleModalComponent,
    TrialPolicyRulesListComponent,
    TrialPolicyMileageRatesListComponent,
    TrialIntegrationComponent,
    TrialRoleToggleComponent,
    VisitAutoPaymentsComponent,
    VisitPreloadPaymentsComponent,
    TrialGenericDiaryComponent,
    TrialPolicyCloneComponent,
    TrialPolicyCardComponent,
    TrialDiaryFormComponent,
    TrialDiariesComponent,
    TrialDiaryFormElementRendererComponent,
    ElementSingleLineComponent,
    ElementCheckboxComponent,
    ElementDateComponent,
    ElementTimeComponent,
    ElementMultiLineComponent,
    ElementNumericComponent,
    ElementRadioComponent,
    ElementDropdownComponent,
    ElementContextMenuComponent,
    ElementSettingsModalComponent,
    TrialDiaryConfigModalComponent,
    TrialDiaryAddRuleModalComponent,
    TrialDiaryRulesComponent,
    ElementSettingsModalComponent,
    TrialContactsTableRowComponent,
    TrialSupportComponent,
    TrialSupportLinksComponent,
    TrialSupportInfoComponent,
    TrialSupportLinkFormComponent,
    TrialContactsTableRowComponent,
    TrialFaqsComponent,
    FaqFormComponent,
    TrialInformationComponent,
    ElementContainerComponent,
    ElementMessageModalComponent,
    ElementVisibilityModalComponent,
    TrialPolicyEdiaryPaymentsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTableModule,
    MatCheckboxModule,
    DragDropModule,
    AdminModule,
    MatInputModule,
    MatIconModule,
    VisitModule,
    FormsModule,
    ButtonComponent,
    ClickOutsideDirective,
    CheckboxComponent,
    ElementLabelComponent,
    ElementOptionListComponent,
    TrialDiaryAddRuleConditionComponent,
    NgClass,
    PlatformChartComponent,
    PanelComponent,
    NgForOf,
    NgIf,
    ReactiveFormsModule,
    NgForOf,
    TrialNotificationsComponent,
    SwitchPanelComponent,
    ElementMessagesComponent,
    ReactiveFormsModule,
    PgoCallout
  ],
  exports: [
    TrialPolicyRulesListComponent,
    TrialPolicyMileageRatesListComponent,
    ElementContextMenuComponent,
  ]
})
export class TrialModule { }
